import {CellTaxonomy} from './constants'
import {BasicCell} from './cells/basic'
import utils from '@eitje/utils'
import {flexRender} from '@tanstack/react-table'
import {t} from '@eitje/bridge'
import {isFunction} from '../../../../helpers'
///////////
// Get cell components through a) lookup with string name, b) from tax as explicit component or c) the fallback compoent
///////////

export const stringToCell = cell => {
	if (typeof cell === 'string') return CellTaxonomy[cell]
	if (isFunction(cell)) return cell
	return null
}

export const getCell = column => {
	const {cell} = column.columnDef || {}
	return stringToCell(cell) || BasicCell
}

///////////
// Render functions
///////////

export const renderCell = cell => {
	// Generically fallback on `null` instead of values such as `undefined` to prevent React crashes.
	const {column, getValue, getContext} = cell
	const {columnDef} = column
	const {customPlaceholder, cell: cellName, format} = columnDef
	const translatedPlaceholder = getTranslatedPlaceholder(cell)

	// Usually we want falsy values to simply be empty, but not when it is a 'yes' or 'no' kind of situation.
	// Printing 'no' is more consistent and much clearer when grouping on a boolean column.
	const showFalsyValue = cellName === 'BooleanCell'

	const value = getValue() || null
	const noValue = !utils.exists(value) && !translatedPlaceholder && !customPlaceholder && !showFalsyValue
	if (noValue) return null

	// We don't want to use Cell components, if not necessary. Cell components might cause issues in Safari and
	// might also be less performant. Yet you need a component if you want to return HTML for a cell.
	const Cell = getCell(column)
	if (!Cell && !format) return value
	if (format) return format(value)

	const renderProps = {...getContext(), translatedPlaceholder}
	return flexRender(Cell, renderProps)
}

export const getTranslatedPlaceholder = cell => {
	const {translatedPlaceholder} = cell.column.columnDef
	if (!translatedPlaceholder) return null
	return t(translatedPlaceholder)
}
